import accountSales from './accountSales.json';
import discount from './discount.json';
import paymentIntegrations from './paymentIntegrations.json';
import settingsEmployees from './settingsEmployees.json';
import addressForm from './addressForm.json';
import discountPopup from './discountPopup.json';
import payment from './payment.json';
import settingsGridButtons from './settingsGridButtons.json';
import advancedCustomerSearch from './advancedCustomerSearch.json';
import duplicateTabs from './duplicateTabs.json';
import posVersionControl from './posVersionControl.json';
import settings from './settings.json';
import alerts from './alerts.json';
import editEmployee from './editEmployee.json';
import printCoupons from './printCoupons.json';
import settingsLanguage from './settingsLanguage.json';
import audio from './audio.json';
import employee from './employee.json';
import productGroupEditTexts from './productGroupEditTexts.json';
import settingsNoteButtons from './settingsNoteButtons.json';
import billTable from './billTable.json';
import employeeStats from './employeeStats.json';
import productGroup from './productGroup.json';
import settingsOnScreenKeyboard from './settingsOnScreenKeyboard.json';
import cafa from './cafa.json';
import fiscalIntegration from './fiscalIntegration.json';
import product from './product.json';
import settingsPayment from './settingsPayment.json';
import campaigns from './campaigns.json';
import giftcard from './giftcard.json';
import productSearch from './productSearch.json';
import settingsPrinter from './settingsPrinter.json';
import cashInOut from './cashInOut.json';
import gridButtons from './gridButtons.json';
import receiptPreview from './receiptPreview.json';
import settingsReceiptTemplates from './settingsReceiptTemplates.json';
import changePassword from './changePassword.json';
import header from './header.json';
import returnTranslation from './return.json';
import settingsScanner from './settingsScanner.json';
import changePin from './changePin.json';
import installer from './installer.json';
import sale from './sale.json';
import settingsTaxRates from './settingsTaxRates.json';
import clockInOut from './clockInOut.json';
import layaway from './layaway.json';
import saleNotes from './saleNotes.json';
import settingsUserInterface from './settingsUserInterface.json';
import common from './common.json';
import limitPerSale from './limitPerSale.json';
import scannerSelection from './scannerSelection.json';
import shipping from './shipping.json';
import contacts from './contacts.json';
import localDBs from './localDBs.json';
import scanSearchResults from './scanSearchResults.json';
import shoppingCart from './shoppingCart.json';
import createCustomer from './createCustomer.json';
import login from './login.json';
import search from './search.json';
import shortcuts from './shortcuts.json';
import createNew from './createNew.json';
import managerOverride from './managerOverride.json';
import Sentry from './Sentry.json';
import SseApi from './SseApi.json';
import customerButtons from './customerButtons.json';
import modalpage from './modalpage.json';
import sessionExpiration from './sessionExpiration.json';
import stockTransfer from './stockTransfer.json';
import customerDisplay from './customerDisplay.json';
import multiCurrency from './multiCurrency.json';
import settingsAgeVerification from './settingsAgeVerification.json';
import switchUser from './switchUser.json';
import customerInformation from './customerInformation.json';
import notifications from './notifications.json';
import settingsAssociatePos from './settingsAssociatePos.json';
import taxExempt from './taxExempt.json';
import customer from './customer.json';
import offer from './offer.json';
import settingsCompany from './settingsCompany.json';
import unpaidInvoice from './unpaidInvoice.json';
import customerNotes from './customerNotes.json';
import offlineLogin from './offlineLogin.json';
import settingsConfiguration from './settingsConfiguration.json';
import urlControl from './urlControl.json';
import customerSearch from './customerSearch.json';
import openCloseDay from './openCloseDay.json';
import settingsCustomerDisplay from './settingsCustomerDisplay.json';
import validation from './validation.json';
import customPrompts from './customPrompts.json';
import orderAssignment from './orderAssignment.json';
import settingsCustomer from './settingsCustomer.json';
import zReport from './zReport.json';
import dataCollectionAcknowledgment from './dataCollectionAcknowledgment.json';
import order from './order.json';
import settingsCustomerSearchResults from './settingsCustomerSearchResults.json';
import deleteAccount from './deleteAccount.json';
import payCheckForm from './payCheckForm.json';
import settingsCustomPayment from './settingsCustomPayment.json';
import settingsShortcuts from './settingsShortcuts.json';

export const dev = {
  accountSales,
  discount,
  paymentIntegrations,
  settingsEmployees,
  addressForm,
  discountPopup,
  payment,
  settingsGridButtons,
  advancedCustomerSearch,
  duplicateTabs,
  posVersionControl,
  settings,
  alerts,
  editEmployee,
  printCoupons,
  settingsLanguage,
  audio,
  employee,
  productGroupEditTexts,
  settingsNoteButtons,
  billTable,
  employeeStats,
  productGroup,
  settingsOnScreenKeyboard,
  cafa,
  fiscalIntegration,
  product,
  settingsPayment,
  campaigns,
  giftcard,
  productSearch,
  settingsPrinter,
  cashInOut,
  gridButtons,
  receiptPreview,
  settingsReceiptTemplates,
  changePassword,
  header,
  return: returnTranslation,
  settingsScanner,
  changePin,
  installer,
  sale,
  settingsTaxRates,
  clockInOut,
  layaway,
  saleNotes,
  settingsUserInterface,
  common,
  limitPerSale,
  scannerSelection,
  shipping,
  contacts,
  localDBs,
  scanSearchResults,
  shoppingCart,
  createCustomer,
  login,
  search,
  shortcuts,
  createNew,
  managerOverride,
  Sentry,
  SseApi,
  customerButtons,
  modalpage,
  sessionExpiration,
  stockTransfer,
  customerDisplay,
  multiCurrency,
  settingsAgeVerification,
  switchUser,
  customerInformation,
  notifications,
  settingsAssociatePos,
  taxExempt,
  customer,
  offer,
  settingsCompany,
  unpaidInvoice,
  customerNotes,
  offlineLogin,
  settingsConfiguration,
  urlControl,
  customerSearch,
  openCloseDay,
  settingsCustomerDisplay,
  validation,
  customPrompts,
  orderAssignment,
  settingsCustomer,
  zReport,
  dataCollectionAcknowledgment,
  order,
  settingsCustomerSearchResults,
  deleteAccount,
  payCheckForm,
  settingsCustomPayment,
  settingsShortcuts,
};
